// extracted by mini-css-extract-plugin
export default {"menu-header":"Menu_menu-header__A2Cr4","menu-items":"Menu_menu-items__MaDau"};